import type { MapGeoJSONFeature } from 'maplibre-gl';

function createFeatureSelectionStore() {
	let selectedFeatures = $state<MapGeoJSONFeature[]>([]);
	let layerIdMap = $state<Record<string, string>>({});
	let currentSelectedFeatureIndex = $state(0);
	const current = $derived<MapGeoJSONFeature | undefined>(
		selectedFeatures[currentSelectedFeatureIndex]
	);
	const currentSystemId = $derived(current ? layerIdMap[current.layer.id] : undefined);

	return {
		get selectedFeatures() {
			return selectedFeatures;
		},
		get layerIdMap() {
			return layerIdMap;
		},
		get currentSelectedFeatureIndex() {
			return currentSelectedFeatureIndex;
		},
		get current() {
			return current;
		},
		get currentSystemId() {
			return currentSystemId;
		},

		setSelectedFeatures(features: MapGeoJSONFeature[]) {
			selectedFeatures = features;
			currentSelectedFeatureIndex = 0;
		},
		clearSelectedFeatures() {
			selectedFeatures = [];
			currentSelectedFeatureIndex = 0;
		},
		setLayerIdMap(map: Record<string, string>) {
			layerIdMap = map;
		},

		/** Advance to next feature, wrapping to 0 at the end */
		incrementSelectedFeature() {
			if (currentSelectedFeatureIndex + 1 < selectedFeatures.length) {
				currentSelectedFeatureIndex += 1;
			} else {
				currentSelectedFeatureIndex = 0;
			}
		},

		/** Go back one feature, wrapping to last index at the start */
		decrementSelectedFeature() {
			if (currentSelectedFeatureIndex > 0) {
				currentSelectedFeatureIndex -= 1;
			} else {
				currentSelectedFeatureIndex = selectedFeatures.length - 1;
			}
		}
	};
}

export const featureSelectionStore = createFeatureSelectionStore();
